<!--<div class="footer">-->
<div class="footer-bg" #myFooter>
    <div class="container">
        <div class="row footer-container">
            <div class="col-md-3 col-sm-12 col-xs-12 footer-img">
                <img ngSrc="assets/img/ICON/image8.png" height="276" width="276" alt="logo">
            </div>
            <div class="col-md-4 col-sm-12 col-xs-12 offset-md-1 footer-about">
                <h3>About</h3>
                <p>
                    {{authService.getDescription()}}
                </p>
            </div>
            <div class="col-md-3 col-sm-12 offset-md-1 col-xs-12 footer-links">
                <h3 class="xs-mt-20">Quick Links</h3>
                <a href="auth/login">Services</a><br />
                <a href="#faq">How this site works</a> <br />
                <a href="support-and-resources">Resources</a><br />
                <a href="#faq">FAQs</a><br />
                <br />
                <button>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <g clip-path="url(#clip0_1_66)">
                            <path d="M12.5002 0.5C8.576 0.5 5.36 3.7064 5.36 7.61984C5.36 9.13616 5.84432 10.5454 6.66392 11.7037L11.6288 20.2868C12.3241 21.1952 12.7863 21.0226 13.3645 20.2388L18.8408 10.9196C18.9512 10.7194 19.0381 10.5063 19.1137 10.2886C19.4612 9.4418 19.6399 8.53521 19.6398 7.61984C19.64 3.7064 16.425 0.5 12.5002 0.5ZM12.5002 3.836C14.6137 3.836 16.2942 5.51264 16.2942 7.61984C16.2942 9.72704 14.6137 11.403 12.5002 11.403C10.387 11.403 8.70584 9.72728 8.70584 7.61984C8.70584 5.51264 10.387 3.83624 12.5002 3.83624V3.836Z" fill="white"/>
                            <path d="M17.0391 12.2379L17.0276 12.2682C17.0312 12.259 17.0341 12.2497 17.0377 12.2406L17.0391 12.2379Z" fill="black"/>
                            <path d="M8.66143 17.0737C5.27119 17.5528 2.89999 18.6988 2.89999 20.3857C2.89999 22.6581 6.86191 24.5001 12.5 24.5001C18.1381 24.5001 22.1 22.6581 22.1 20.3857C22.1 18.6988 19.729 17.5528 16.339 17.0737L15.8694 17.8734C18.4244 18.2279 20.18 18.9729 20.18 19.8373C20.18 21.0493 16.7415 22.0316 12.5 22.0316C8.25847 22.0316 4.81999 21.0493 4.81999 19.8373C4.81975 18.9757 6.56383 18.2315 9.12679 17.8756C8.97199 17.6082 8.81647 17.3413 8.66143 17.0737Z" fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_1_66">
                                <rect width="24" height="24" fill="white" transform="translate(0.5 0.5)"/>
                            </clipPath>
                        </defs>
                    </svg>
                    Locate Us
                </button>
            </div>
        </div>
    </div>
</div>
<!--</div>-->
